import {City} from '../model/city.model';
import {Injectable} from '@angular/core';
import {CityService} from '../service/city.service';
import {Keys, StorageService} from '../service/storage.service';

@Injectable()
export class CityInteractor {
    private readonly cityService: CityService;
    private readonly storageService: StorageService;

    constructor(cityService: CityService, storageService: StorageService) {
        this.cityService = cityService;
        this.storageService = storageService;
    }

    async getAll(): Promise<City[]> {
        return await this.cityService.getAll(this.storageService.getObjectFromSession(Keys.PARTNER_ID));
    }
}
